export const metadata_fields = {
  'News Item': ['title', 'preview', 'chapeu', 'image', 'id', 'description', 'Subject', 'subjects', 'created_import'],
};
